export function openBlob(blob, target = '_blank') {
    // Crear una URL para el Blob
    const blobUrl = URL.createObjectURL(blob)
    // Abrir la URL en una nueva pestaña
    window.open(blobUrl, target)
}
